<template>
    <div class="bind-door">
        <EditDialog title="绑定已有出入口" width="600px" :show="visible">
            <div style="text-align: right; margin-bottom: 10px">
                <el-input size="mini" v-model="searchKey" style="width: 50%"></el-input>
            </div>
            <el-table size="mini" :data="filterTableData" style="width: 100%; margin-bottom: 20px">
                <el-table-column prop="DoorName" label="名称" width="180"> </el-table-column>
                <el-table-column prop="Direction" label="方向">
                    <template #default="{ row }">
                        <span v-if="row.Direction == 1">正向</span>
                        <span v-else>反向</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作">
                    <template #default="{ row }">
                        <el-button :disabled="canBind(row.DoorID)" @click="handleBind(row)" icon="el-icon-plus" size="mini" type="warning"
                            >绑定
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <template #button>
                <div class="dialog-footer">
                    <el-button size="mini" @click="handleCancel">取消</el-button>
                </div>
            </template>
        </EditDialog>
    </div>
</template>

<script>
export default {
    name: "BandDoor",
    props: {
        visible: {
            type: Boolean,
        },
        entityId: {
            required: true,
            type: String,
        },
        existList: {
            type: Array,
        },
    },
    computed: {
        filterTableData() {
            if (this.searchKey) {
                return this.tableData.filter((item) => item.DoorName.includes(this.searchKey));
            }
            return this.tableData;
        },
    },
    data() {
        return {
            searchKey: "",
            tableData: [],
            myExistList: [],
        };
    },
    methods: {
        canBind(id) {
            let ids = this.myExistList.map((item) => item.DoorID);
            if (ids.includes(id)) {
                return true;
            }
            return false;
        },
        handleBind(row) {
            this.$confirm("确定执行该操作吗？", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                let url = this.$route.query.tid ? "/Tenant/BindDoor?tid=" + this.$route.query.tid : "/Entity/BindDoor";
                let params = { ...row, EntityID: this.entityId };
                this.$ajax.post(url, params).then((res) => {
                    this.$message.success("操作成功");
                    this.myExistList.push(row);
                });
            });
        },
        handleCancel() {
            this.$emit("refresh", true);
            this.$emit("update:visible", false);
        },
        getDoors() {
            let url = this.$route.query.tid ? "/Tenant/GetDoors?tid=" + this.$route.query.tid : "/Entity/GetDoors";
            this.$ajax.post(url).then((res) => {
                if (res.Data) {
                    this.tableData = [...res.Data];
                }
            });
        },
    },
    created() {
        if (this.existList) {
            this.myExistList = [...this.existList];
        }
        this.getDoors();
    },
};
</script>

<style scoped></style>
